(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"] && !Shopify.designMode) return;
  try {
    

  class CartNote extends HTMLElement {

    constructor() {

      super();

      this.addEventListener(
        'change',
        debounce((event) => {

          const body = JSON.stringify({
            note: event.target.value
          });

          fetch(
            `${routes.cart_update_url}`,
            {
              ...fetchConfig(),
              ...{
                body
              }
            }
          );

        }, 300)
      );

    }

  }

  customElements.define('cart-note', CartNote);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-2-columns-left"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-2-columns-right"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-testimonial-links"]) return;
  try {
    
(() => {
  const products = {"Beef Bone Marrow Stock - Nutrient-Rich Broth for Dogs & Cats":"/products/beef-bone-marrow-stock","Bone Marrow Stock - Chicken - for Dogs & Cats":"/products/chicken-bone-marrow-stock","Bone Marrow Stock - Duck - for Dogs & Cats":"/products/duck-bone-marrow-stock","Bone Marrow Stock - Lamb - for Dogs & Cats":"/products/lamb-bone-marrow-stock","Bone Marrow Stock - Turkey - for Dogs & Cats":"/products/turkey-bone-marrow-stock","Bow Ties American Flag":"/products/bow-ties","Calendula Herbal Salve - Soothing & Healing Skin Care":"/products/calendula-herbal-salve","Catfish, Beef Liver & Brown Rice - for Cats 8 oz. - 1/2 lb - XSmall":"/products/catfish-beef-liver-organic-brown-rice-formula-for-cats","Chamomile Tincture - 1 oz - Natural Calm & Relaxation":"/products/chamomile-tincture","Cheesies Himalayan Yak Cheese Dog Chew – Long-Lasting & Natural Treat 1.5 oz":"/products/yak-yakety-yak","Chicken & Brown Rice - For Cats 8 oz. - 1/2 lb. - XSmall":"/products/cat-chicken-and-brown-rice","Dandelion Tincture - 1 oz - Liver Support & Detox":"/products/dandelion-tincture","Dog Dry Food - Variety Pack 4oz. - Small":"/products/variety-pack-of-4oz-kibbles","Duck & Sweet Potatoes Formula - For Dogs 16 oz. - 1 lb - Small":"/products/duck-sweet-potato-fresh-dog-food","Fish Oil Omega-3":"/products/shinto-s-omega-3-fish-oil-for-dogs-cats-wild-caught-pure-fresh","Glucosamine & Chondroitin with MSM for Pets - Joint Support Supplement 8 oz. Liquid":"/products/supplements-glucosamine-chondroitin-msm","Handmade Beaded Medicine Pouch Necklace – Native-Inspired Artisan Craft":"/products/beaded-medicine-pouch","Natural Beef Esophagus Chews – Healthy & Digestible Dog Treats":"/products/beef-weasand-esophagus","Natural Digestive Support for Pets | Slippery Elm Bark for Dogs & Cats":"/products/slippery-elm-bark-for-dogs-cats","Recipe Card - Chicken & Brown Rice WET Formula for Dogs":"/products/dog-recipe-card","Reversible Sweaters XS / Lenny":"/products/reversible-sweaters","Scratchy Allergy Relief – Chinese Herbal Formula for Dogs & Cats (2oz)":"/products/itchy-scratchy-allergy-relief","Shinto Dog Dry Food - Angus & Brown Rice Recipe 4 oz.  travel/treat size":"/products/angus-organic-brown-rice-kibble-for-dogs","Shinto Dog Dry Food - Catfish & Brown Rice Recipe 4 oz.  Travel/Treat Size":"/products/catfish-beef-liver-organic-brown-rice-kibble-for-dogs","Shinto Dog Dry Food - Lamb & Brown Rice Recipe 4 oz.  Travel/Treat Size - Small":"/products/lamb-brown-rice-kibble-for-dogs","Shinto Turkey & Beef Spleen Jerky Treats for Dogs & Cats – Sticks & Ends":"/products/turkey-beef-spleen-jerky-treats-for-dogs-cats","Shinto's Turkey & Brown Rice Formula - For Dogs 16 oz. - 1 lb - Small":"/products/turkey-brown-rice-fresh-dog-food","Shinto’s All-Purpose Plant Food – Liquid Fertilizer for Indoor &Outdoor Plants 2 oz.":"/products/all-purpose-plant-food","Shinto’s Angus & Brown Rice Formula – Premium Wet Dog Food 16 oz. - 1 lb. - Small":"/products/angus-beef-brown-rice-fresh-dog-food","Shinto’s Beef Femur Marrow Bones – Dehydrated Dog Treats Large (7-8\")":"/products/treats-marrow-bones","Shinto’s Catfish, Beef Liver & Brown Rice Formula – Premium Wet Dog Food – Complete & Balanced Meal 16 oz. - 1 lb. - Small":"/products/catfish-beef-liver-brown-rice-fresh-dog-food","Shinto’s Chicken & Brown Rice Dry Dog Food – Premium, Gluten-Free Formula 4 oz. - Travel/Treat Size":"/products/dogkibble-chicken-and-brown-rice","Shinto’s Chicken & Brown Rice – The #1 Cleansing Formula for Gut & pH Health 16 oz. - 1 lb. - Small":"/products/chicken-brown-rice-fresh-dog-food","Shinto’s Natural Bully Sticks – Large Pizzle Dog Chews – Long-Lasting Treats for Dental Health":"/products/pizzle","Shinto’s Peanut Butter Cookies – Delicious Treats for Dogs":"/products/treats-peanut-butter-cookies","Shinto’s Pork Belly Cookies – Tasty Dog Treats":"/products/treats-pork-belly-cookies","Shinto’s Turkey & Beef Liver Jerky – Healthy Treats for Dogs & Cats":"/products/treats-turkey-liver-jerky","Shinto’s Turkey & Brown Rice Dry Dog Food – Premium, Gluten-Free Formula 4 oz.  Travel/Treat size":"/products/dogkibble-turkey-and-brown-rice","Shinto’s Turkey & Quinoa Formula for Dogs – Premium, Balanced, & Natural Dog Food 16 oz. - 1 lb. - Small":"/products/turkey-quinoa-fresh-dog-food","Shinto’s Whole Food Supplement for Cats - Complete Daily Nutrition 3 oz.":"/products/cat-whole-food-supplement","Shinto’s Wild Bison & Brown Rice Dry Dog Food – Premium, Grain-Free Formula 4 oz.  Travel/Treat Size":"/products/dogkibble-bison-liver-and-beets","Shinto’s Wild Bison, Turkey, Beets & Beef Liver Formula – #4 Detoxing Formula 16 oz. - 1 lb. - Small":"/products/wild-bison-beets-fresh-dog-food","Shinto’s Yams & Split Peas Fiber Mixer for Dogs & Cats 16 oz":"/products/copy-of-yam-fiber-mixer-2pk","Special Event Ties Rainbow":"/products/special-event-ties","TrueBlue Fast & Fresh Dental Wipes – Natural Oral Care for Dogs & Cats":"/products/dental-wipes-fast-fresh","Tulum HandMade Leash and Collars Leash":"/products/tulum-hm","Turkey & Beef HEART Jerky - Treats for Dogs & Cats -Sticks/Ends":"/products/turkey-beef-heart-jerky-treats-for-dogs-cats","Turkey & Beef KIDNEY Jerky- Treats for Dogs & Cats - Sticks/Ends":"/products/turkey-beef-kidney-jerky-treats-for-dogs-cats","WholeFood Supplement for Dogs - Complete Daily Nutrition 3 oz.":"/products/dog-whole-food-supplement","Wunderball Small (1-20lbs)":"/products/wunderball","Zip Up Microfiber Fleece - for Dogs XS / Green":"/products/zip-up-microfiber-fleece","Beets Mash Fiber Mixer – Nutrient-Rich Superfood for Dogs & Cats 16 oz":"/products/beets-fiber-mixer","Lamb & Sweet Potatoes Formula - For Dogs 16 oz. - 1 lb. - Small":"/products/lamb-sweet-potato-fresh-dog-food"};
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  const links = new Map(Object.entries(products).map(([title, url]) => [normalize(title), url]));
  const connect = () => {
    const widget = document.getElementById('ReviewsWidget');
    if (!widget || widget.dataset.shProductLinks) return;
    widget.dataset.shProductLinks = 'true';
    const update = () => {
      widget.querySelectorAll('.R-ContentList__item').forEach(item => {
        const heading = item.querySelector('.item__review .R-TextHeading--xxs');
        if (!heading) return;
        const title = heading.textContent.trim();
        const url = links.get(normalize(title));
        let link = item.querySelector('.sh-testimonial-product-link');
        if (!url) {
          if (link) link.remove();
          return;
        }
        if (!link) {
          link = document.createElement('a');
          link.className = 'sh-testimonial-product-link';
          item.querySelector('.item__review').appendChild(link);
        }
        if (link.getAttribute('href') !== url) link.setAttribute('href', url);
        if (link.textContent !== title) link.textContent = title;
      });
    };
    new MutationObserver(update).observe(widget, {childList:true,subtree:true,characterData:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, {once:true});
  else connect();
  document.addEventListener('shopify:section:load', connect);
})();

  } catch(e) { console.error(e); }
})();
})();
